import { all, fork, takeLatest } from 'redux-saga/effects';

import { requestItalianAggregatesSaga } from '@sagas/filing/aggregates/requestItalianAggregatesSaga';
import { handleRequest } from '@sagas/request';
import {
  processingAggregatesRequest,
  requestAdditionalAggregatesECSL,
  requestAggregates,
  requestAggregatesECSL,
  requestAggregatesItaly,
} from '@store/filing/aggregates/aggregates.reducer';

import { processingAggregatesRequestSaga } from './processingAggregatesRequestSaga';
import { requestAggregatesSaga } from './requestAggregatesSaga';
import { watchPollProcessingAggregatesSaga } from './watchPollProcessingAggregatesSage';

export default all([
  fork(watchPollProcessingAggregatesSaga),
  takeLatest(processingAggregatesRequest.type, processingAggregatesRequestSaga),
  takeLatest(requestAggregates.type, requestAggregatesSaga),
  takeLatest(requestAggregatesItaly.type, requestItalianAggregatesSaga),
  takeLatest(requestAggregatesECSL.type, handleRequest),
  takeLatest(requestAdditionalAggregatesECSL.type, handleRequest),
]);
